import * as React from 'react';
import { MdExpandMore, MdExpandLess } from 'react-icons/md';

import styles from './expandable.scss';

export enum ExpandableButtonPosition{
  bottom = 'bottom',
  top = 'top'
}
export interface ExpandableProps {
  textDisplayMore?: String;
  textDisplayLess?: String;
  useMargin?: boolean;
  buttonPosition?: ExpandableButtonPosition;
  content: (collapsed: boolean) => React.ReactNode;
}

export interface ExpandableState {
  collapsed: boolean;
}

export class Expandable extends React.Component<ExpandableProps, ExpandableState> {
  public state: Readonly<ExpandableState> = {
    collapsed: true
  };

  private toggleExpander = (e: React.SyntheticEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  public render () {
    const {content, textDisplayMore, textDisplayLess, useMargin = true, buttonPosition = ExpandableButtonPosition.bottom} = this.props;
    const {collapsed} = this.state;

    const text = collapsed ? textDisplayMore : textDisplayLess;

    const buttonMore = <span className={`expandable ${useMargin ? styles.useMargins : ''} ${styles.expandableLink}`}>
      {text ? ' ' : ''}
      <a href="#" className={`${!text ? styles.noText : ''}`} onClick={this.toggleExpander}>
        {text}{collapsed ? <MdExpandMore /> : <MdExpandLess />}
      </a></span>;

    if (buttonPosition === ExpandableButtonPosition.top) {
      return <>
        {buttonMore}
        {content && content(collapsed)}
      </>;
    }
    return <>
      {content && content(collapsed)}
      {buttonMore}
    </>;
  }
}
